import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkComment } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-comment',
  templateUrl: './ax-comment.component.html',
  styleUrls: ['./ax-comment.component.scss'],
})
export class AxCommentComponent implements OnInit {
  @Input() comment: WorkComment;
  @Input() allowComments = false;
  @Output() sendAnswer: EventEmitter<Partial<WorkComment>> = new EventEmitter<Partial<WorkComment>>();
  public newComment = '';
  public showAnswerButton = false;

  constructor() {
  }

  ngOnInit() {
  }

  send() {
    this.sendAnswer.emit({
      comment: this.newComment,
      parentId: this.comment.id,
    });
    this.newComment = '';
  }
}
